import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { WarehouseProvider } from './providers/WarehouseProvider';
import { OrderListPage } from './pages/OrderListPage';
import { OrderLayout } from './pages/OrderLayout';
import { PickListPage } from './pages/PickListPage';
import { OrderDetailsPage } from './pages/OrderDetailsPage';
import { OrdersViewPage } from './pages/OrdersViewPage';

export const WarehouseRoutes: React.FC = () => {
  return (
    <WarehouseProvider>
      <Routes>
        <Route index element={<OrderListPage />} />
        <Route path="order/:orderId" element={<OrderLayout />}>
          <Route index element={<Navigate to="picklist" replace />} />
          <Route path="picklist" element={<PickListPage />} />
          <Route path="details" element={<OrderDetailsPage />} />
          <Route path="orders" element={<OrdersViewPage />} />
        </Route>
      </Routes>
    </WarehouseProvider>
  );
};
